import { tasksSlice } from './slice';

export const {
  add,
  loadingProjectTasks,
  loadedProjectTasks,
  loadingAllTasks,
  loadedAllTasks,
  creating,
  created,
  failed,
  updating,
  updated,
  revert,
  deleting,
  deleted,
  restored,
} = tasksSlice.actions;
